// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rtinu","col":"styles_col__sTLcx"};